import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const HERO_IMG = '/inside1.png';
const ABOUT_IMG = '/food2.png';

export default function Home() {
  return (
    <main className="home">
      {/* Hero */}
      <section className="home-hero">
        <img src={HERO_IMG} alt="Restaurant ambiance" />
        <div className="home-hero__overlay" />
        <div className="home-hero__content">
          <p className="home-hero__eyebrow">Chesterfield, Michigan</p>
          <h1>Giuseppe's<br /><em>Restaurant</em></h1>
          <div className="home-hero__divider" />
          <p className="home-hero__tagline">Italian Cuisine at Its Finest</p>
          <a href="tel:5869484900" className="home-hero__phone">586-948-4900</a>
          <div className="home-hero__ctas">
            <a href="https://order.yourmenu.com/giuseppesristorante" target="_blank" rel="noopener noreferrer" className="btn-primary">Order Now</a>
            <Link to="/menu" className="btn-outline btn-outline--light">View Our Menu</Link>
            <Link to="/contact" className="btn-outline btn-outline--light">Reserve a Table</Link>
          </div>
        </div>
      </section>

      {/* Quick Links Bar */}
      <div className="gold-bar" />
      <section className="quick-links">
        <div className="quick-links__inner">
          {[
            { to: '/about', icon: '🍷', label: 'About Us' },
            { to: '/menu', icon: '🍝', label: 'Our Menu' },
            { to: '/gallery', icon: '📸', label: 'Gallery' },
            { to: '/contact', icon: '📍', label: 'Contact' },
          ].map(({ to, icon, label }) => (
            <Link to={to} key={to} className="quick-links__item">
              <span className="quick-links__icon">{icon}</span>
              <span className="quick-links__label">{label}</span>
            </Link>
          ))}
        </div>
      </section>
      <div className="gold-bar" />

      {/* About Preview */}
      <section className="section home-about">
        <div className="container home-about__inner">
          <div className="home-about__img-wrap">
            <img src={ABOUT_IMG} alt="Italian food" />
          </div>
          <div className="home-about__text">
            <p className="home-about__pre">Welcome to</p>
            <h2 className="section-title">Your Newest Food<br />Adventure Awaits</h2>
            <div className="divider-ornament"><span>✦</span></div>
            <p>
              When it comes to Italian cuisine, there's nothing better than authentic dishes
              made with traditional recipes and ingredients sourced locally and made from scratch.
            </p>
            <p>
              Take your taste buds on a trip to Italy with your newest favorite Italian restaurant,
              Giuseppe's Restaurant in Chesterfield, Michigan — serving the community for over 25 years.
            </p>
            <Link to="/about" className="btn-primary" style={{ marginTop: '2rem' }}>
              Learn More
            </Link>
          </div>
        </div>
      </section>

      {/* Features Band */}
      <section className="features-band">
        <div className="features-band__inner">
          {[
            { title: 'Locally Sourced', desc: 'Fresh produce from Michigan farms' },
            { title: 'Made From Scratch', desc: 'Every dish prepared fresh daily' },
            { title: 'Catering & Events', desc: 'Banquet hall & special occasions' },
            { title: '25+ Years', desc: 'A Chesterfield institution since 1999' },
          ].map(f => (
            <div className="features-band__item" key={f.title}>
              <div className="features-band__line" />
              <h4>{f.title}</h4>
              <p>{f.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Banner */}
      <section className="cta-banner">
        <div className="cta-banner__content">
          <h2>Ready to Experience Authentic Italian?</h2>
          <p>Call us to make a reservation or stop by — we'd love to have you.</p>
          <div className="cta-banner__actions">
            <a href="https://order.yourmenu.com/giuseppesristorante" target="_blank" rel="noopener noreferrer" className="btn-primary">Order Now</a>
            <a href="tel:5869484900" className="btn-outline btn-outline--light">Call 586-948-4900</a>
            <Link to="/menu" className="btn-outline btn-outline--light">Browse Menu</Link>
          </div>
        </div>
      </section>
    </main>
  );
}
